import { SepecialtyNodeService } from "../../services/models/specialtyNode";
const moduleSpecialty = {
	namespaced: true,
	state: {
		specialties: [],
		loading: false,
	},
	getters: {
		getSpecialties(state) {
			return state.specialties;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadSpecialties(state, specialties) {
			state.specialties = specialties;
		}
	},
	actions: {
		async loadSpecialties({ commit, state }) {
			state.loading = true;
			const stablishmentId = window.localStorage.getItem("stablishment");
			let specialties = await SepecialtyNodeService.getByDestinationNode(stablishmentId);
			commit("loadSpecialties", specialties);
			state.loading = false;
		}
	}
}

export default moduleSpecialty;